import { render, staticRenderFns } from "./CreateLiquidUnclaimedReportTwo.vue?vue&type=template&id=0136cfc7&scoped=true&"
import script from "./CreateLiquidUnclaimedReportTwo.vue?vue&type=script&lang=js&"
export * from "./CreateLiquidUnclaimedReportTwo.vue?vue&type=script&lang=js&"
import style0 from "./CreateLiquidUnclaimedReportTwo.vue?vue&type=style&index=0&id=0136cfc7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0136cfc7",
  null
  
)

export default component.exports